import { render } from "./IconPlayArrow.vue?vue&type=template&id=51e5ba40"
import script from "./IconPlayArrow.vue?vue&type=script&lang=js"
export * from "./IconPlayArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__